<template>
  <div class="flex flex-col">
    <div class="flex gap-5 lg:gap-8 lg:bg-grayscale-10 lg:p-6 lg:rounded-t-12">
      <div class="min-w-16 w-16 h-16 md:min-w-100 md:h-100 md:w-100">
        <image-kit
          :path="pro?.profilePicture || 'placeholder.png'"
          width="64"
          height="64"
          :alt="`${getDisplayName(pro, true)} ${pro.worksAt}`"
          class="rounded-full md:hidden"
        />
        <image-kit
          :path="pro?.profilePicture || 'placeholder.png'"
          width="100"
          height="100"
          :alt="`${getDisplayName(pro, true)} ${pro.worksAt}`"
          class="rounded-full hidden md:block"
        />
      </div>
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-3">
          <h1 class="font-bold text-20 leading-140 md:text-24">
            {{ getDisplayName(pro, true) }}
          </h1>
          <ClientOnly>
            <Popper :hover="true" :options="{ placement: 'bottom' }">
              <i
                class="icon-star-checked-filled text-20 cursor-default text-accent-orange"
              />
              <template #content>
                <div class="bg-popper-bg px-1 py-2 text-popper-text">
                  <p class="whitespace-nowrap text-xs font-medium">
                    Verified by Xposure
                  </p>
                </div>
              </template>
            </Popper>
          </ClientOnly>
        </div>
        <span class="text-15">{{ pro.worksAt }}</span>
        <div v-if="pro.country || pro.city" class="flex items-center">
          <span v-if="country" class="mr-3">{{ country.flag }}</span>
          <p class="text-grayscale-90 font-normal text-12 leading-160">
            {{ getVisibleLocation(pro) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { PropType } from "vue";
import type { User } from "../../../types/user";
import { getDisplayName } from "@/utils/display-name";
import Popper from "vue3-popper";
import utils from "@/utils/constants";
import ImageKit from "@/components/imagekit/ImageKit.vue";
import { getVisibleLocation } from "@/utils/display-name";

const props = defineProps({
  pro: {
    type: Object as PropType<User>,
    required: true,
  },
});

const countries = ref(utils.countries);
const country = computed(() =>
  countries.value.find((country) => country.code === props.pro.country),
);
</script>
